import { i18nKeys } from 'translationTypes'
import i18n from '../../../../i18n'

export default {
  primaryAction: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__identificationNumber__primaryAction),
  usaTitle: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__identificationNumber__usa__title),
  usaLabel: () =>
    i18n.t(
      i18nKeys.bankOnboardingSplash__identificationNumber__usa__inputLabel
    ),
  caTitle: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__identificationNumber__ca__title),
  caLabel: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__identificationNumber__ca__inputLabel),
  ausTitle: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__identificationNumber__aus__title),
  ausLabel: () =>
    i18n.t(
      i18nKeys.bankOnboardingSplash__identificationNumber__aus__inputLabel
    ),
  idNumberProperLength: () =>
    i18n.t(
      i18nKeys.bankOnboardingSplash__identificationNumber__idNumberProperLength
    ),
  idNumberNotNull: () =>
    i18n.t(
      i18nKeys.bankOnboardingSplash__identificationNumber__idNumberNotNull
    ),
}
